import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function CategoriesFormatter({ info }) {
  const { value } = getInfo(info)
  if (!value) return '--'
  return <TruncateWithTooltipFormatter value={value.map(category => category.name).join(", ")} />
}
